import { User } from './types';

export const identify = (user: User) => {
  window.Beacon?.('identify', user);
};
